import {
  getProductList,
  clearFilterSort,
  searchClean,
} from 'reduxpath/ducks/Product/List'

import {
  getProductById,
  getStandardByProductType,
  getPortfolios,
} from 'reduxpath/ducks/Product/Detail'

import {
  getPortfolioById,
  setSelectedClean,
} from 'reduxpath/ducks/Product/Portfolio'

import {
  getCountries,
  getServices,
  setSelectionsCountry,
  setSelectionsService,
  setSelectedCountry,
  setSelectedService,
  getProductTypes,
  getFormat,
} from 'reduxpath/ducks/Reference'

import Home from 'units/Product'
import List from 'units/Product/units/List'
import Detail from 'units/Product/units/Detail'
import Portfolio from 'units/Portfolio'

const list = (store) => {
  store.dispatch(clearFilterSort())
  store.dispatch(searchClean())

  const { selectedCountry, selectedService } = store.getState().Reference

  if (selectedCountry) {
    store.dispatch(setSelectedCountry(selectedCountry))
  }
  if (selectedService) {
    store.dispatch(setSelectedService(selectedService))
  }

  const qs = {
    sort: {
      isEligible: 'DESC',
      createdAt: 'DESC',
    },
    limit: 10,
    skip: 0,
    where: {
      isEligible: true,
    },
  }
  if (selectedCountry) {
    qs.where.country = selectedCountry
  }
  if (selectedService) {
    qs.where.service = selectedService
  }

  store.dispatch(
    getProductList(qs),
  )

  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
    }),
  )

  store.dispatch(
    getServices((services) => {
      store.dispatch(setSelectionsService(services.rows))
    }),
  )

  store.dispatch(getProductTypes())
  store.dispatch(getFormat())
}

const detail = (store, id) => {
  store.dispatch(getProductById(id, (product) => {
    const productType = product.productType.id
    store.dispatch(
      getPortfolios(product.id),
    )
    store.dispatch(
      getStandardByProductType(productType, {
        sort: 'sequence DESC',
        limit: 10,
        skip: 0,
      }),
    )
  }))
}

const portfolio = (store, portfolioId, productId) => {
  store.dispatch(setSelectedClean())
  store.dispatch(getPortfolioById(portfolioId))
  store.dispatch(getProductById(productId))
}


export default {
  populate: {
    list,
    detail,
    portfolio,
  },
  components: {
    Home,
    List,
    Detail,
    Portfolio,
  },
}
